import { Box, IconButton, Image, Menu, MenuButton, MenuItem, MenuList, Switch, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import { RiDeleteBinLine, RiFileEditLine } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux';
import CTable from '../../../components/Table/table'
import { deleteAnnouncementRequest, activateAnnouncementRequest } from '../../../modules/admin-modules/announcements/Actions';
import { openCreateAnnouncement } from '../../../modules/admin-modules/models/Actions';
import { API } from '../../../constants';

const AnnouncementsTable = ({ setAdd, setSelectedData }) => {
    const announcements = useSelector((state) => state.announcements.announcements)
    const dispatch = useDispatch()
    const isLoading = useSelector((state) => state.announcements.isLoading)
    const [offset, setPage] = useState(0);
    const [size, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [selected, setSelected] = useState({
        id: ''
    })
    const viewData = (data) => {
        setSelectedData(data);
        setSelected(data);
        setAdd(false);
        dispatch(openCreateAnnouncement());
    };
    const baseUrl = API || "https://api.asquera.com/";
    
    const Data =
        announcements?.map((data) => {
            return {
                ...data,
                id: data?.id,
                title: data?.title,
                content: data?.content,
                image: data?.image ? (
                    <Image 
                        src={`${baseUrl}${data.image}`} 
                        alt={data.title}
                        maxW="100px"
                        maxH="100px"
                        objectFit="cover"
                    />
                ) : null,
                active: (
                    <Box onClick={(e) => e.stopPropagation()}>
                        <Switch 
                            isChecked={data?.active === 1}
                            colorScheme="green"
                            onChange={() => {
                                dispatch(activateAnnouncementRequest(data?.id));
                            }}
                        />
                    </Box>
                ),
                edit: (
                    <IconButton
                        variant='outline'
                        border='0'
                        color='gray.600'
                        aria-label='Edit Announcement'
                        fontSize='20px'
                        icon={<RiFileEditLine />}
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent row click from opening modal
                            setSelectedData(data);
                            setAdd(false);
                            dispatch(openCreateAnnouncement());
                        }}
                    />
                ),
                delete: (<IconButton
                    variant='outline'
                    border='0'
                    color='gray.600'
                    aria-label='Delete Announcement'
                    fontSize='20px'
                    icon={<RiDeleteBinLine color='red' />}
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent row click from opening modal
                        dispatch(deleteAnnouncementRequest(data?.id));
                    }}
                />)
            };
        })
    const columns = [
        {
            Header: 'العنوان',
            accessor: 'title'
        },
        {
            Header: 'المحتوى',
            accessor: 'content',
            Cell: ({ value }) => (
                <Text maxW="200px" isTruncated>
                    {value}
                </Text>
            )
        },
        {
            Header: 'الصورة',
            accessor: 'image'
        },
        {
            Header: 'نشط',
            accessor: 'active'
        },
        {
            Header: 'تعديل',
            accessor: 'edit'
        },
        {
            Header: 'حذف',
            accessor: 'delete'
        }
    ];


    return (
        <CTable
            selectedData={viewData}
            Columns={columns}
            Data={Data}
            path={'openModel'}
            Actions
            Title={``}
            subTitle=''
            btnTitle=""
            placeHolder=""
            noSearchBar={true}
            noFilter={true}
            footerBtnTitle
            filterList
            addButton
            addButtonTitle=""
            setPage={setPage}
            setPerPage={setPerPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            noSecondSearchBar={true}
            isLoading={isLoading}
            perPage={size}
            totalPage={Math.ceil(announcements?.length / 10)}

        />
    )
}

export default AnnouncementsTable

